import styled, { css } from 'styled-components';

export const PageHeader = styled.div`
	background: #fff;
	padding: 16px 16px;

	& .ant-breadcrumb > span:last-child {
		font-weight: 600 !important;
		opacity: 0.8;
	}

	& .ant-breadcrumb-link {
		font-size: 12px;
	}

	& > header {
		width: 100%;
		display: flex;
		align-items: flex-end;
		justify-content: space-between;
		margin-bottom: 32px;

		& > h2 {
			color: rgba(0, 0, 0, 0.75) !important;
			display: flex;
			align-items: center;
			margin: 0;
			margin-bottom: -10px;
		}

		& > div.buttons {
			display: flex;
			align-items: flex-end;
			justify-content: space-between;
		}
	}
`;

export const TableHeader = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 8px;

	& > div.actions {
		padding-right: 24px;
		margin-right: 24px;
		border-right: 1px solid #dedede;
		display: flex;
		align-items: flex-end;
		justify-content: space-between;
		flex: 1;

		& > span {
			font-size: 12px;
			color: rgba(0, 0, 0, 0.65);
		}

		& > div {
			display: flex;
			align-items: center;
			justify-content: flex-end;

			& > .ant-btn {
				margin: 0 2px;
			}
		}
	}
`;

export const CardContainer = styled.div`
	width: 100%;
	margin: 16px 0;
	padding: 0 16px;

	& > ._card > .ant-card-body {
		padding: 16px;
	}

	& div.tab-content {
		padding: 16px !important;
	}

	div.align-end {
		display: flex;
		justify-content: flex-end;
	}
`;

export const TrackSignature = styled.div`
	width: 100%;
	border: 1px solid #dedede;
	border-radius: var(--border-radius-base);
	padding: 16px;
	display: flex;
	flex-direction: column;
	align-items: center;

	& > div.main {
		width: 100%;
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 24px;

		& > div.buttons {
			display: flex;
			align-items: center;
			justify-content: flex-end;

			& > button {
				margin-left: 6px;
			}
		}
	}

	& > div.infos {
		width: 100%;
		display: flex;
		align-items: center;

		& > div {
			display: flex;
			align-items: center;
			justify-content: space-between;

			&:first-child {
				margin-right: 32px;
			}

			& > strong {
				margin-right: 6px;
			}
		}
	}
`;

export const SeeTrack = styled.span`
	font-weight: 500;
	color: var(--primary);
	cursor: pointer;
`;

export const UploadsZonesContainer = styled.div`
	display: flex;

	& > div {
		flex: 1;

		&:first-child {
			padding-right: 25px;
			border-right: 1px solid #f1f1f1;
		}

		&:last-child {
			padding-left: 25px;
		}
	}
`;

export const CastersList = styled.ul`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-top: 16px;
	height: 500px;
	overflow-y: auto;
	padding: 6px;
`;

export const CastersItem = styled.li`
	width: 100%;
	display: flex;
	gap: 24px;
	border-radius: var(--border-radius-base);
	border: 1px solid #dedede;
	padding: 16px;
	align-items: center;
	cursor: pointer;

	&:hover {
		border-color: var(--primary);
	}

	& > div.caster-infos {
		display: flex;
		flex-direction: column;

		& > strong {
			font-size: 18px;
		}

		& > small {
			font-size: 13px;
		}
	}

	${({ selected }) =>
		selected &&
		css`
			pointer-events: none;
			border-color: var(--primary);
			box-shadow: 0px 0px 0px 2px var(--primary);
		`}
`;

export const SearchCasterContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
`;

export const ResultButtons = styled.div`
	width: 100%;
	display: flex;
	gap: 8px;
	align-items: center;
	justify-content: center;
`;
